"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reorderMenuEndpoint = exports.menuEndpoint = void 0;
var t = __importStar(require("typed-validators"));
var routes_1 = require("~shared/utils/routes");
var menuQueryValidator = t.object({
    required: {
        lang: t.oneOf(t.string('en'), t.string('zh'))
    },
    optional: {
        all: t.nullishOr(t.boolean())
    }
});
var reorderMenuItemQueryValidator = t.object({
    deletedItems: t.array(t.object({
        id: t.number(),
        type: t.oneOf(t.string('link'), t.string('category'))
    })),
    positionChanges: t.array(t.object({
        categoryId: t.nullOr(t.number()),
        contents: t.array(t.object({
            id: t.number(),
            type: t.oneOf(t.string('link'), t.string('category'))
        }))
    }))
});
var topMenuValidator = t.array(t.object({
    id: t.number(),
    priority: t.number(),
    type: t.string()
}));
var linkValidator = t.object({
    id: t.number(),
    text: t.string(),
    url: t.string(),
    priority: t.number()
});
var menuItemValidator = t.object({
    id: t.number(),
    text: t.string(),
    url: t.string(),
    priority: t.number(),
    links: t.array(linkValidator)
});
var menuValidator = t.array(t.oneOf(linkValidator, menuItemValidator));
var subMenuValidator = t.oneOf(linkValidator, menuItemValidator);
var menuReturnValidator = t.oneOf(t.object({
    status: t.string('failure')
}), t.object({
    status: t.string('success'),
    menus: menuValidator
}));
var reorderMenuItemReturnValidator = t.object({
    status: t.oneOf(t.string('failure'), t.string('success'))
});
exports.menuEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/menus',
    method: 'post',
    requestBody: menuQueryValidator,
    responseBody: menuReturnValidator
});
exports.reorderMenuEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/menus/reorder',
    method: 'post',
    requestBody: reorderMenuItemQueryValidator,
    responseBody: reorderMenuItemReturnValidator
});
//# sourceMappingURL=menus.js.map